// import Router from '@/router'
const tinabaConfig = {
  appleStoreLink: 'https://itunes.apple.com/it/app/tinaba/id1063359568?mt=8',
  googleStoreLink: 'market://details?id=it.tinaba.app'
};

function openFallback (ts: number) {
  return function() {
      const wait = 1000 + 500;
      if (typeof tinabaConfig.googleStoreLink === "string" && (Date.now() - ts) < wait) {
          window.location.href = tinabaConfig.googleStoreLink;
      }
  }
}

interface PayWithTinabaLinks {
  deeplinkUrl: string;
  viaBrowserDeeplinkUrl: string;
}

export function getTinabaPayUrl (paymentDetails: PayWithTinabaPayload): PayWithTinabaLinks  {
  let viaBrowserDeeplinkUrl = `https://deeplink.tinaba.it/merchant`,
      params = '?',
      paymentCode;
  const scheme = 'it.tinaba.app',
      path = '/dl';

  if ("paymentCode" in paymentDetails) {
    paymentCode = paymentDetails.paymentCode;
  } else {
    throw new Error("Error on retrive paymentCode");
  }

  let deeplinkUrl = `${scheme}:/${path}${params}paymentcode=${encodeURIComponent(paymentCode)}&tinabaPay=true`;
  // QR e link: deeplink.tinaba.it/merchant?paymentCode={code} (paymentCode con la C maiuscola e senza '&',
  // altrimenti lo scanner delle versioni dell'app già installate non lo riconosce)
  viaBrowserDeeplinkUrl += `${params}paymentCode=${encodeURIComponent(paymentCode)}`;

  return {
    deeplinkUrl,
    viaBrowserDeeplinkUrl
  }
}

export function payWithTinaba (paymentDetails: PayWithTinabaPayload) {
  // emitWidgetClickedToGoogleAnalytics();
  // holds the final URL that will be used in the generated QR code and links to redirection page
  // const { deeplinkUrl } = getTinabaPayUrl(paymentDetails)
  const deeplinkUrl = `https://deeplink.tinaba.it/merchant?paymentCode=${encodeURIComponent(paymentDetails.paymentCode)}`

  /*
  if (window.location.href.includes('fromAppTinaba=true')) {
    parent.postMessage(deeplinkUrl, '*');
    return;
  }
  */
 

  const agent = navigator.userAgent.toLowerCase();
  if (agent.indexOf('iphone') > -1 || agent.toLowerCase().indexOf('ipod') > -1) {
    // window.open(deeplinkUrl)
    window.location.href = deeplinkUrl;

    /*
    const now = (new Date()).valueOf();
    window.location.replace(deeplinkUrl)
    setTimeout(() => {
      if ((new Date()).valueOf() - now > 5500) return;
      window.location.replace(tinabaConfig.appleStoreLink);
    }, 5000);
    return null
    */
  } else if (agent.indexOf('android') > -1) {
    window.open(deeplinkUrl)
    /*
    window.location.replace(deeplinkUrl)
    setTimeout(openFallback(Date.now()), 1000)
    return null
    */
  } else {
    return false
  }
}